import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ViewComponent } from './view/view.component';
import { HomeComponent } from './home/home.component';

const APP_ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'view/:track',
    component: ViewComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(APP_ROUTES, {useHash: true, enableTracing: false } ) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/app/app-routing.module.ts